export const userTableHeader = [
  {
    id: 'sno',
    numeric: false,
    label: 'S.No',
    disabled: true,
  },
  {
    id: 'userId',
    numeric: false,
    label: 'User Id',
    disabled: true,
  },
  {
    id: 'firstName',
    numeric: false,
    label: 'Name',
    disabled: true,
  },
  {
    id: 'email',
    numeric: false,
    label: 'Email',
    disabled: true,
  },
  {
    id: 'action',
    numeric: false,
    label: 'Actions',
    disabled: true,
  },
];

export const userFields = [
  {
    fieldName: 'fullName',
    fieldTitle: 'Full Name',
    validationObj: {
      required: 'Please Enter User Full Name',
    },
    fieldType: 'text',
  },

  {
    fieldName: 'designation',
    fieldTitle: 'Designation',
    validationObj: {
      required: 'Please Enter Designation',
    },
    fieldType: 'text',
  },

  {
    fieldName: 'email',
    fieldTitle: 'Email',
    validationObj: {
      required: 'Please Enter User Email',
    },
    fieldType: 'email',
  },

  {
    fieldName: 'role',
    fieldTitle: 'Role',
    validationObj: {
      required: 'Please Select User Role',
    },
    fieldType: 'select',
  },
];
